/* RESPONSIBLE TEAM: team-reporting */

import Model, { attr } from '@ember-data/model';
import type { ScheduleRecipients } from 'embercom/types/reporting/scheduled-delivery';
import type { ExportRule } from 'embercom/models/reporting/dataset-export-schedule';

export interface ScheduleOwnerAvatar {
  initials: string;
  color: string;
  imageUrls: {
    square25: string | null;
    square50: string | null;
    square128: string | null;
  };
  imageDarkUrls: {
    square25: string | null;
    square50: string | null;
    square128: string | null;
  };
  imageUrl: string | null;
  imageDarkUrl: string | null;
  shape: string;
  label: string;
}

export interface ScheduleOwner {
  name: string;
  avatar: ScheduleOwnerAvatar;
}

export default class ScheduledExternalShare extends Model {
  @attr('number') declare appId: number;
  @attr('string') declare name: string;
  @attr('number') declare reportId: number;
  @attr('number') declare reportVersion: number | null;
  @attr('string') declare reportName: string;
  @attr('string') declare message: string;
  @attr() declare recipients: ScheduleRecipients;
  @attr() declare exportRule: ExportRule;
  @attr('string') declare timeZone: string;
  @attr('string') declare lastSuccessfulRun: string | null;
  @attr('string') declare nextScheduledRun: string;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;
  @attr('string') declare deliveryAt: string;
  @attr() declare owner: ScheduleOwner | null;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'reporting/scheduled-external-share': ScheduledExternalShare;
  }
}
